// import { generateId } from "./utils";
// import { Roles } from "./constants";
// import * as jose from "jose";
import BASE_CONFIG from "./config";
const BASE_URL = BASE_CONFIG.API_BASE_URL;


const uploadRequest = async (url, file, token) => {
  let headers = {
  };
  if (token) {
    headers.Authorization = token;
  }

  try {
    let response = await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: headers,
      body: file,
    });
    return await response.json();
  } catch (err) {
    console.log(err);
  }
  return null;
};

const postRequest = async (url, body, token) => {
  let headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = token;
  }

  try {
    let response = await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: headers,
      body: body,
    });
    // if (response.status != 200) {
    //   return null;
    // }
    response = response.json();
    return response;
  } catch (err) {
    console.log(err);
  }
  return null;
};

const getRequest = async (url, token) => {
  let headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = token;
  }

  try {
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      headers: headers,
    });
    if (response.status != 200) {
      return null;
    }
    response = response.json();
    return response;
  } catch (err) {
    console.log(err);
  }
  return null;
};

const createRoom = async ({ userToken, url, isService, productId, policyDetail, skipVerifyingCarReg, carNoValid = false, carRegNo = null, isMobile = false }) => {
  let apiBody = { data: url.inc, isServiceChat: isService, productId: productId, skipVerifyingCarReg: skipVerifyingCarReg, carNoValid: carNoValid, carRegNo: carRegNo, isMobile: isMobile }
  if (policyDetail.key) {
    apiBody[policyDetail.value] = policyDetail.key
  }
  if (url.pageurl) {
    apiBody['windowPageUrl'] = url.pageurl;
  }

  if (url && url.terminc && url.productId) {
    apiBody['terminc'] = url.terminc
    apiBody['productId'] = url.productId
  }
  if (url && (url.utm_term || url.utm_source || url.utm_medium || url.utm_campaign)) {
    apiBody['utm_term'] = url.utm_term
    apiBody['utm_source'] = url.utm_source
    apiBody['utm_medium'] = url.utm_medium
    apiBody['utm_campaign'] = url.utm_campaign
  }
  apiBody['cs'] = url.cs || ''
  let response = await postRequest(`${BASE_URL}/room/create`, JSON.stringify(apiBody), userToken);
  if (response && response.status === 'success') {
    return response["result"]
  }
  else if (response.code === 403) {
    console.log(response["result"])
    return response["result"]
  }
  else {
    console.log(response)
    return {
      isOffline: true,
      offlineMsg: response.message
    }
  }
};

const createUser = async (URLData) => {
  let apiBody = { data: URLData.inc }
  //console.log(apiBody)
  let response = await postRequest(`${BASE_URL}/customer/register`, JSON.stringify(apiBody), null);
  if (response) {
    return {
      id: response["result"]["userId"],
      token: response["result"]["token"],
    };
  }
  return null;
};

const getRoomData = async (roomToken) => {
  let response = await postRequest(`${BASE_URL}/room/messages`, null, roomToken);
  if (response) {
    return response["result"]
  }
  return null;
};

const uploadCustomerDocument = async (formdata, roomToken) => {
  formdata.append("source", "uploadCustomerDocument");
  let response = await uploadRequest(`${BASE_URL}/uploadDoc/uploadDocument`, formdata, roomToken);
  if (response) {
    return response;
  }
  return null;
};

const updateCustomerFeedback = async (roomToken, score, remark) => {
  let apiBody = { score: score, remark: remark }
  let response = await postRequest(`${BASE_URL}/room/csat`, JSON.stringify(apiBody), roomToken)
  if (response) {
    return response;
  }
  return null;
};
const updateCustomerTicketFeedback = async (roomToken, status) => {
  let response = await postRequest(`${BASE_URL}/room/querystatus/agent`, JSON.stringify({ queryResolveStatus: status }), roomToken)
  if (response) {
    return response;
  }
  return null;
};

const agentServiceCsatFeedback = async (roomToken, body) => {
  let apiBody = body;
  let response = await postRequest(`${BASE_URL}/room/service/agent/csat`, JSON.stringify(apiBody), roomToken)
  if (response) {
    return response;
  }
  return null;
};


const reGenDocument = async (docId, roomToken) => {
  return await postRequest(`${BASE_URL}/uploadDoc/regenerateDocument`,
    docId,
    roomToken
  );
};

const closeRoom = async (roomToken, userToken) => {
  return postRequest(`${BASE_URL}/agent/closeRoom`,
    JSON.stringify({
      "roomToken": roomToken,
    }),
    userToken
  );
};

const generateOTPApi = async (userToken, payload) => {
  return postRequest(`${BASE_URL}/authentication/sendotp`,
    JSON.stringify(payload),
    userToken
  );
}

const verifyOTPApi = async (userToken, payload) => {
  return postRequest(`${BASE_URL}/authentication/validateotp`,
    JSON.stringify(payload),
    userToken
  );
}

const getFAQ = async (roomToken) => {
  return getRequest(`${BASE_URL}/room/faq`,
    roomToken
  );
};

const getChatHistory = async (roomToken, letLastmagTimeStamp) => {
  return postRequest(
    `${BASE_URL}/history/messages/`,
    JSON.stringify({ letLastmagTimeStamp: letLastmagTimeStamp }),
    roomToken,
  )
}


const getWebCallingAuthToken = async (roomToken) => {
  return getRequest(
    `${BASE_URL}/customer/webCallingAuthToken`,
    roomToken,
  )
}
const makeWebCall = async (roomToken, webCallToken) => {
  return postRequest(
    `${BASE_URL}/customer/makeWebCall`,
    JSON.stringify({ webCallToken: webCallToken }),
    roomToken,
  )
}
const api = { createRoom, createUser, getRoomData, uploadCustomerDocument, updateCustomerFeedback, agentServiceCsatFeedback, reGenDocument, closeRoom, getFAQ, generateOTPApi, verifyOTPApi, getChatHistory, getWebCallingAuthToken, makeWebCall, updateCustomerTicketFeedback };
export default api;
